import * as React from 'react'
import { cn } from '../../lib/utils'

export type FilterPanelProps = React.HTMLAttributes<HTMLElement> & {
  title?: React.ReactNode
  actions?: React.ReactNode
  layout?: 'grid' | 'toolbar'
}

export const FilterPanel = React.forwardRef<HTMLElement, FilterPanelProps>(
  (
    {
      title,
      actions,
      children,
      className,
      layout = 'grid',
      ...props
    },
    ref,
  ) => {
    const isToolbar = layout === 'toolbar'

    return (
      <section
        ref={ref}
        className={cn(
          'rounded-[var(--surface-lifted-radius)] border border-[var(--surface-lifted-border)] bg-[var(--surface-lifted-bg)] p-[var(--filter-padding)] shadow-[var(--surface-lifted-shadow)]',
          className,
        )}
        {...props}
      >
        {(title || (actions && !isToolbar)) && (
          <div className="mb-[var(--filter-gap)] flex flex-wrap items-center justify-between gap-[var(--filter-gap)]">
            {title && (
              <h2 className="m-0 text-[length:var(--field-label-size)] font-semibold text-[var(--color-text)]">
                {title}
              </h2>
            )}
            {actions && !isToolbar && (
              <div className="ml-auto flex flex-wrap items-center gap-[var(--filter-gap)]">
                {actions}
              </div>
            )}
          </div>
        )}
        <div
          data-testid="filter-panel-fields"
          className={cn(
            'grid grid-cols-1 gap-[var(--filter-gap)] md:grid-cols-2',
            isToolbar
              ? 'filter-toolbar-grid'
              : 'xl:grid-cols-4',
          )}
        >
          {children}
          {actions && isToolbar && (
            <div
              data-testid="filter-panel-inline-actions"
              className="flex items-end justify-end"
            >
              {actions}
            </div>
          )}
        </div>
      </section>
    )
  },
)
FilterPanel.displayName = 'FilterPanel'
